module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"redirecting":"Auth0 のログイン画面へ移動しています…"}},"en":{"label":{"redirecting":"Redirecting to the Auth0 login page…"}}}')
  delete Component.options._Ctor
}
